import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box } from '@mui/material';
import { closeSnackbar, SnackbarKey } from 'notistack';
import StyledBox from './styles';

export default function DetectionSnackbarActions(props: {
  actionLabel: string;
  onAction: () => void;
}) {
  const { actionLabel, onAction } = props;

  return function render(snackbarKey: SnackbarKey) {
    return (
      <StyledBox>
        <Box
          component="button"
          type="button"
          className="openButton"
          onClick={onAction}
        >
          {actionLabel}
        </Box>
        <Box
          component="button"
          type="button"
          className="closeButton"
          onClick={() => { closeSnackbar(snackbarKey); }}
        >
          <CloseRoundedIcon sx={{ fontSize: 18 }} />
        </Box>
      </StyledBox>
    );
  };
}
